import { render, staticRenderFns } from "./AdminBranchen.vue?vue&type=template&id=44eb9654&scoped=true&"
import script from "./AdminBranchen.vue?vue&type=script&lang=ts&"
export * from "./AdminBranchen.vue?vue&type=script&lang=ts&"
import style0 from "./AdminBranchen.vue?vue&type=style&index=0&id=44eb9654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eb9654",
  null
  
)

export default component.exports